export default __webpack_public_path__ + "static/media/wp.47134711.png";